import { apiCall } from './base';

export const updateProject = (hash, { immediately = false, ...data }) =>
  apiCall(`/projects/${hash}`, { method: 'PUT', data, immediately });

export const fetchProjectSkills = (hash) =>
  apiCall(`/projects/${hash}/skills`);

export const postProjectSkill = (hash, { immediately = false, ...data }) =>
  apiCall(`/projects/${hash}/skills`, { method: 'POST', data, immediately });

export const deleteProjectSkill = (hash, { immediately = false, ...data }) =>
  apiCall(`/projects/${hash}/skills`, {
    method: 'DELETE',
    data,
    immediately,
  });

export const saveProject = ({ immediately = false, ...data }) => 
  apiCall(`/projects/`, { method: 'POST', data, immediately })
  